<template>
  <VanPopup
    v-model:show="store.img.showCustomModal"
    class="h-[490px]"
    position="bottom"
    round
    teleport="body"
    @close="store.img.showCustomModal = false"
  >
    <div class="overflow-hidden h-full grid grid-rows-[auto_auto_1fr]">
      <div class="flex flex-col p-4 pb-0">
        <button
          class="btn btn-primary btn-sm rounded self-end"
          @click="emit('update:generate')"
        >
          <i class="iconfont icon-paint"></i>
          {{ t("Buttons.generateImage") }}
        </button>
      </div>
      <VanTabs
        class="w-full overflow-hidden grid grid-rows-[auto_1fr] all-tabs"
        v-model:active="store.img.selectTab"
        :ellipsis="false"
        line-width="20"
        line-height="2"
      >
        <VanTab :title="t('painting.featuresCueWord')"> </VanTab>
      </VanTabs>
      <div class="p-4 overflow-hidden" v-if="store.img.selectTab === 0">
        <div class="flex flex-col gap-2 items-center justify-center">
          <div class="font-bold text-base self-start">
            {{ t("painting.people.feature") }}
          </div>
          <MateTraitSelection
            enable-selection
            v-model:selected-trait-id="store.img.custom.traitId"
          />
        </div>
        <div class="my-4">
          <div class="font-bold text-base self-start">
            {{ t("painting.englishCueWords") }}
          </div>
          <div v-if="store.img.promptLoading" class="flex justify-center mt-10">
            <VanLoading color="#fff" />
          </div>
          <VanField
            v-else
            v-model="store.img.custom.prompt"
            rows="1"
            type="textarea"
            :placeholder="t('painting.enterEnglishCueWordsText')"
            class="mt-2.5 text-[#ABABAB] h-[100px]"
          />
        </div>
      </div>
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useStory } from "@/stores/story";
import { useI18n } from "vue-i18n";
import { watch } from "vue";
import { ImageStyleSelectionInstance } from "@/components/mobile/generation/ImageStyleSelection.vue";
import { nextTick } from "vue";
// State
const store = useStory();

const emit = defineEmits(["update:generate"]);

const { t } = useI18n();
const styleRef = ref<ImageStyleSelectionInstance | null>(null);

watch([() => store.img.selectTab, () => store.img.showCustomModal], () => {
  const { selectTab, showCustomModal, custom } = store.img;
  if (selectTab === 1 && showCustomModal) {
    nextTick(() => {
      styleRef.value!.selectedStyleId = custom.style;
    });
  }
});
</script>

<style scoped>
:deep(.all-tabs .van-tabs__content) {
  overflow: auto;
}

:deep(.van-tabs__nav .van-tab__text) {
  text-overflow: unset;
}
</style>
